import { render } from "./AccountAdmins.vue?vue&type=template&id=2bc8db0a&scoped=true"
import script from "./AccountAdmins.vue?vue&type=script&lang=js"
export * from "./AccountAdmins.vue?vue&type=script&lang=js"

import "./AccountAdmins.vue?vue&type=style&index=0&id=2bc8db0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc8db0a"]])

export default __exports__